<template>
    <div class="update-admin">
        <RsStep :active="step" :steps="['设置新管理手机号', '新管理员签署合同', '完成移交']"></RsStep>
        <div class="content-box first" style="height: 70vh;">
            <template v-if="step === 0">
                <el-form :model="formData" ref="formData" label-position="top" :rules="rules" label-width="160px"
                    style="width: 420px;margin: 0 auto;">
                    <el-form-item prop="telephone" label="新管理员手机号">
                        <el-input v-model="formData.telephone" type="text"></el-input>
                    </el-form-item>
                    <el-form-item label="" style="text-align: center;">
                        <el-button type="primary" @click="onSubmit" :loading="btnLoading">确认移交管理员</el-button>
                        <p class="color-danger" style="line-height: 20px;margin-top: 20px;">
                            移交企业管理员完成后，您手机号将无法登录秀动发行的企业账号。</p>
                    </el-form-item>
                </el-form>
            </template>

            <template v-if="step === 1">
                <div class="alert">
                    <h3 style="text-align: center;">已提交，签署合同后将移交完成</h3>
                    <p>1. 当前管埋员手机号将收到一条来自“电子牵”的短信，需要打开短信中的链接，并完成授权书签署。 <br />
                        2. 签署完成后，本企业账号的管理员将会自动移交，新的管理员可以登录该企业账号，而当前账号将自动退出该企业
                    </p>
                </div>
            </template>

            <template v-if="step === 2">
                <div class="sr-result success">
                    <span class="icon"></span>
                    <div class="content">
                        <h5>管理员移交成功</h5>
                        <p>您的手机号已经无法登录该企业账号， 如果需要继续使用秀动发行发行作品， 可注册个人发行账号。</p>
                        <el-button type="primary" disabled>退出登录</el-button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { updateManager } from '@/api/user';
    export default {
        data() {
            return {
                step: 0,
                formData: {
                    telephone: ''
                },
                rules: {
                    telephone: [{ required: true, message: '请输入手机号' }, { validator: this.$utils.validatePhone }],
                },
                btnLoading: false
            };
        },
        computed: {},
        mounted() { },
        methods: {
            async updateAdmin() {
                this.btnLoading = true;
                const response = await updateManager(this.formData.telephone);
                const { msg, state } = response.data;
                this.btnLoading = false;
                if (!state) return this.$message.error(msg || '');
                this.step = 1;
            },
            onSubmit() {
                this.$refs['formData'].validateField(['telephone'], (err) => {
                    if (!err) this.updateAdmin();
                });
            }
        },
    };
</script>

<style lang="scss">
    .update-admin {
        .alert {
            margin: 80px auto;
            width: 705px;

            h3 {
                font-size: 24px;
                color: $-text-950;
                line-height: 24px;
                font-style: normal;
                margin-bottom: 30px;
            }

            p {
                font-size: 14px;
                color: $-text-600;
                line-height: 30px;
            }
        }
    }
</style>
